import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-seo-tools',
  templateUrl: './seo-tools.component.html',
  styleUrl: './seo-tools.component.css'
})
export class SeoToolsComponent {
  constructor(@Inject(DOCUMENT) private document: Document, private titleService: Title, private meta: Meta) {
    this.titleService.setTitle("SEO Tools | RankAhead");
    this.meta.addTag({
      name: 'description',
      content: 'Optimize your website effortlessly with our free SEO tools and improve search engine visibility for better rankings.'
    });
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');
  }
}
